import { DISPLAY_CURRENCIES } from "common/constants.ts";
import { selectDisplayCurrency } from "@shared/slices/common.slice.ts";
import { useDispatch, useSelector } from "react-redux";
import Flex from "common/Boxes/Flex.tsx";
import RowLabel from "common/Home/Sider/RowLabel.tsx";
import SquareSwitch from "common/Switch/SquareSwitch.tsx";
import { BTC } from "common/Icons/Icons.tsx";
import React, { CSSProperties } from "react";
import styled from "styled-components";
import { sharedLib } from "@shared/services/shared.service.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

interface CurrencyToggleProps {
  style?: CSSProperties;
  /** New look menu rows: a leading icon. */
  icon?: React.ReactNode;
}

const CurrencyToggle = ({ style, icon }: CurrencyToggleProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const dispatch = useDispatch();
  const displayCurrency = useSelector(selectDisplayCurrency);

  const onChange = () => {
    const nextCurrency =
      displayCurrency === DISPLAY_CURRENCIES.USD
        ? DISPLAY_CURRENCIES.BTC
        : DISPLAY_CURRENCIES.USD;
    dispatch(sharedLib.slices.common.actions.setDisplayCurrency(nextCurrency));
  };

  return (
    <Flex style={style}>
      <RowLabel icon={icon}>{t("sider.currency")}</RowLabel>
      <SquareSwitch
        items={[
          { key: DISPLAY_CURRENCIES.USD, label: <IconWrapper>$</IconWrapper> },
          {
            key: DISPLAY_CURRENCIES.BTC,
            label: (
              <IconWrapper>
                <BTC />
              </IconWrapper>
            ),
          },
        ]}
        selectedKey={displayCurrency}
        onChange={onChange}
      />
    </Flex>
  );
};

export default CurrencyToggle;

const IconWrapper = styled.div`
  width: 16px;
  display: flex;
  justify-content: center;
`;
